import Dashboard from './Dashboard'

export default function Home() {

    return (
        <Dashboard />
    );
}